import * as React from 'react';
import { InputProps } from 'interfaces';
import { Input } from '../input/input';
import { CypressI } from 'interfaces/cypress';
import { DatePickerSimple } from '@/components/common/date-picker';
import Icons from '@/const/icons';
import clsx from 'clsx';
import { getYear } from 'date-fns';

export const InputDate: React.FC<
	InputProps &
		CypressI &
		React.InputHTMLAttributes<HTMLInputElement> & {
			dateDefault?: string;
			onSelected?: (value: string) => void;
			fromDate?: Date | undefined;
			toDate?: Date | undefined;
		}
> = ({
	name,
	setValueInput,
	dateDefault,
	classNameInput,
	classNameTitle,
	placeholder,
	onSelected,
	classNameTrigger,
	startYear = getYear(new Date()) - 1,
	endYear = getYear(new Date()) + 100,
	fromDate,
	toDate,
	dateRange,
	...props
}) => {
	return (
		<>
			<DatePickerSimple
				dateRange={dateRange}
				dateCurrent={dateDefault}
				classNameTrigger={classNameTrigger}
				setValue={(data) => {
					data && setValueInput(name, data, { shouldDirty: true });
					data && onSelected && onSelected(data);
				}}
				disabled={props.disabled}
				startYearCustom={startYear}
				endYearCustom={endYear}
				fromDate={fromDate}
				toDate={toDate}
				buttonContent={
					<Input
						name={name}
						type="text"
						value={dateDefault}
						iconRight={Icons.calendar}
						colorIcon={clsx({ '!cursor-none': props.disabled })}
						classNameIcon={clsx('!size-5', props.classNameIcon)}
						placeholder={placeholder || 'MM/DD/YYYY'}
						classNameInput={clsx(
							'!placeholder-opacity-black font-normal text-opacity-black',
							classNameInput
						)}
						classNameTitle={clsx('font-normal', classNameTitle)}
						{...props}
					/>
				}
			/>
		</>
	);
};
